<template>
  <div class="Exportbatch">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn type="button" @click="exportexcelbatch(tokenexport, exportthn,exportbln,exportps,paparnegeriexport)" color="blue white white--text">
            <span class="material-icons">file_download</span>
            {{ $t("muatturun") }} {{ $t("batch") }}
          </v-btn> -->
             <download-excel
              :data = "papardatabatch"
              type="csv"
              name="batch.xls"
             
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("batch") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatabatch"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>

  </div>
</template>
<script>
import i18n from "@/i18n";

import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import axios from "../../plugins/axios";
export default {
  Name: "Exportbatch",
  setup() {},
  props: ["papardatabatch", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    headers: [
      { text: i18n.t("kaw"), value: "KAW" },
      { text: i18n.t("Bulan"), value: "BULAN" },
      { text: i18n.t("Tahun"), value: "TAHUN" },
      { text: i18n.t("kodneg"), value: "KODNEG" },
      { text: i18n.t("bno"), value: "BNO" },
      { text: i18n.t("Pusingan"), value: "PUSINGAN" },
      { text: i18n.t("jumlahborang"), value: "JumBorang" },
      { text: i18n.t("borangselesai"), value: "totalBorangSelesai" },
      { text: i18n.t("penyeliaprosesan"), value: "namaPProsesan" },
      { text: i18n.t("penyeliaoperasi"), value: "namaPOperasi" },
    ],
  }),
  methods: {
    handleSuccess(val){
      console.log(val)
    },
    handleError(val){
      console.log(val)
    },
    async exportexcelbatch(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/batch/exportbatchserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    rmnull(data) {
      console.log(data)
      return (data === null) ? '' : String(data)
    }
  },
  watch:{


  }
};
</script>